import CONSTANTS from 'app/constants'
import router from 'app/router'

export default {

    namespaced: true,

    state: {

        streaks: {

            period: 'year'

        },

		weight: {

            chart: 'polar',
            band: 0

        },

		wins: {

            band: false,
			threshold: 3

        },

		plays: {

            band: false,
			threshold: 3

        },

		count: {

            band: 2,
            sort: 'total',
			threshold: 3

        },

		duration: {

            sort: 'total'

        },

        period: CONSTANTS.INSIGHTS.PERIOD.ALLTIME,
		players: 0

    },

    getters: {

        active: function(state) {

            return {
                'streaks.period': state.streaks.period !== 'year',
				'weight.chart': state.weight.chart !== 'polar',
				'weight.band': state.weight.band !== 0,
				'wins.band': state.wins.band !== false,
				'wins.threshold': state.wins.threshold !== 3,
				'plays.band': state.plays.band !== false,
				'plays.threshold': state.plays.threshold !== 3,
				'count.band': state.count.band !== 2,
				'count.sort': state.count.band !== 'total',
				'count.threshold': state.count.threshold !== 3,
				'duration.sort': state.count.band !== 'total',
                'period': state.period,
				'players': state.players
            }

        },

        values: function(state) {

            return {
				'streaks.period': state.streaks.period,
				'weight.chart': state.weight.chart,
				'weight.band': state.weight.band,
				'wins.band': state.wins.band,
				'wins.threshold': state.wins.threshold,
				'plays.band': state.plays.band,
				'plays.threshold': state.plays.threshold,
				'count.band': state.count.band,
				'count.sort': state.count.sort,
				'count.threshold': state.count.threshold,
				'duration.sort': state.duration.sort,
                'period': state.period,
				'players': state.players
            }

        },

		'streaks/period': function(state) {

			return state.streaks.period

		},

		'weight/chart': function(state) {

			return state.weight.chart

		},

		'weight/band': function(state) {

			return state.weight.band

		},

		'wins/band': function(state) {

			return state.wins.band

		},

		'wins/threshold': function(state) {

			return state.wins.threshold

		},

		'plays/band': function(state) {

			return state.plays.band

		},

		'plays/threshold': function(state) {

			return state.plays.threshold

		},

		'count/band': function(state) {

			return state.count.band

		},

		'count/threshold': function(state) {

			return state.count.threshold

		},

		'count/sort': function(state) {

			return state.count.sort

		},

		'duration/sort': function(state) {

			return state.duration.sort

		},

        period: function(state) {

            return state.period

        },

        players: function(state) {

            return state.players

        }

    },

    mutations: {

        reset: function(state) {

			state.streaks.period = 'year'
			state.count.band = 2
			state.count.sort = 'total'
			state.count.threshold = 3
			state.wins.band = false
			state.wins.threshold = 3
			state.plays.band = false
			state.plays.threshold = 3
			state.weight.band = 0
			state.weight.chart = 'polar'
			state.duration.sort = 'total'
            state.period = CONSTANTS.INSIGHTS.PERIOD.ALLTIME
            state.players = 0

        },

		'streaks/period': function(state, value) {

			state.streaks.period = value

		},

		'weight/chart': function(state, value) {

			state.weight.chart = value

		},

		'weight/band': function(state, value) {

			state.weight.band = value

		},

		'wins/band': function(state, value) {

			state.wins.band = value

		},

		'wins/threshold': function(state, value) {

			state.wins.threshold = value

		},

		'plays/band': function(state, value) {

			state.plays.band = value

		},

		'plays/threshold': function(state, value) {

			state.plays.threshold = value

		},

		'count/band': function(state, value) {

			state.count.band = value

		},

		'count/sort': function(state, value) {

			state.count.sort = value

		},

		'count/threshold': function(state, value) {

			state.count.threshold = value

		},

		'duration/sort': function(state, value) {

			state.duration.sort = value

		},

        period: function(state, value) {

            state.period = value

        },

        players: function(state, value) {

            state.players = value

        }

    },

    actions: {

        analyse: function(context, params) {

            return new Promise(function(resolve) {

                context.commit('reset')

                if (params !== undefined) {

					if (params['wins.threshold']) context.state.wins.threshold = parseInt(params['wins.threshold'])
					if (params['wins.band']) context.state.wins.band = parseInt(params['wins.band'])
					if (params['plays.threshold']) context.state.plays.threshold = parseInt(params['plays.threshold'])
					if (params['plays.band']) context.state.plays.band = parseInt(params['plays.band'])
					if (params['duration.sort']) context.state.duration.sort = params['duration.sort']
					if (params['streaks.period']) context.state.streaks.period = params['streaks.period']
					if (params['count.sort']) context.state.count.sort = params['count.sort']
					if (params['count.band']) context.state.count.band = parseInt(params['count.band'])
					if (params['count.threshold']) context.state.count.threshold = parseInt(params['count.threshold'])
					if (params['weight.band']) context.state.weight.band = parseInt(params['weight.band'])
					if (params['weight.chart']) context.state.weight.chart = params['weight.chart']
                    if (params.period) context.state.period = params.period
                    if (params.players) context.state.players = params.players

                }

                resolve()

            })

        },

        route: function(context) {

            var urlParams = {}
            
			if (context.state.duration.sort !== 'total') urlParams['duration.sort'] = context.state.duration.sort
			if (context.state.streaks.period !== 'year') urlParams['streaks.period'] = context.state.streaks.period
			if (context.state.count.sort !== 'total') urlParams['count.sort'] = context.state.count.sort
			if (context.state.count.band !== 2) urlParams['count.band'] = context.state.count.band
			if (context.state.count.threshold !== 3) urlParams['count.threshold'] = context.state.count.threshold
			if (context.state.weight.band !== 0) urlParams['weight.band'] = context.state.weight.band
			if (context.state.wins.band !== false) urlParams['wins.band'] = context.state.wins.band
			if (context.state.wins.threshold !== 3) urlParams['wins.threshold'] = context.state.wins.threshold
			if (context.state.plays.band !== false) urlParams['plays.band'] = context.state.plays.band
			if (context.state.plays.threshold !== 3) urlParams['plays.threshold'] = context.state.plays.threshold
			if (context.state.weight.chart !== 'polar') urlParams['weight.chart'] = context.state.weight.chart
            if (context.state.period !== 'all') urlParams.period = context.state.period
            if (context.state.players !== 0) urlParams.players = context.state.players

            router.replace({name: 'InsightsPlayers', query: urlParams}).catch(function() {})

        }

    }

}